<template>
    <template v-if="ModulesInstantLotto.cartInstant.length > 0">
        <h3 class="betslip__body-title">
            {{ getTranslatedText(LOTTO_INSTANT.GAME_TITLE) }}
        </h3>
        <div class="betslip__body-list">
            <div class="betslip__body-list__item" v-for="(item, index) in ModulesInstantLotto.cartInstant" :key="index">
                <div class="betslip__body-list__item-line border">
                    <div class="betslip__title"></div>
                    <span class="betslip__price">
                        {{ renderPrice(item.price) }}
                    </span>
                </div>

                <div class="betslip__body-list__item-line">
                    <span class="betslip__title-column">
                        {{ renderTextTickets(item.selection) }}
                    </span>
                    <span class="betslip__text-value"> {{ renderDate(item.eventDate) }}</span>
                </div>

                <ButtonCommon
                    :isNoHover="true"
                    :isDisable="isLoadingButton"
                    type="outline"
                    value="remove"
                    @on-click-button-common="onRemoveItem(item)"
                />
            </div>
        </div>
        <div class="betslip__footer">
            <div class="betslip__footer-total">
                <span class="betslip__footer-total-title">
                    {{ getTranslatedText('total') }} ({{ ModulesInstantLotto.cartInstant?.length }})
                </span>
                <span class="betslip__footer-total-price">
                    {{ renderTotal() }}
                </span>
            </div>
            <div class="betslip__footer-box-btn">
                <ButtonCommon
                    :isNoHover="true"
                    :isDisable="isLoadingButton"
                    type="outline"
                    value="Effacer"
                    @on-click-button-common="onShowConfirmClear()"
                />
                <ButtonCommon
                    :isNoHover="true"
                    :isLoading="isLoadingButton"
                    value="Valide"
                    @on-click-button-common="onTransactCart()"
                />
            </div>
        </div>
    </template>
    <div v-else class="betslip__empty">
        <p>{{ getTranslatedText('cart empty') }}</p>
        <ButtonCommon
            :isNoHover="true"
            type="outline"
            value="Add Bets"
            @on-click-button-common="$emit('continue-paying')"
        />
    </div>
    <Dialog
        :show="dialog.isOpen"
        :buttonLeftName="`close`"
        :buttonRightName="`ok`"
        title="confirm"
        content="Are you sure you want to delete"
        @close="dialog.isOpen = false"
        @accept="onClearCart()"
    />
</template>
<script>
import { mapState } from 'vuex';
import { formatDateUTC, formatPrice } from '@/utils/utils';

import LottoService from '@/services/loto/loto.service';

import languageMixins from '@/mixins/language-mixins';
import functionMixins from '@/mixins/function-utils';
import printMixins from '@/mixins/print-mixins';

import ButtonCommon from '@/components/common/button/button.vue';
import Dialog from '@/components/common/dialog/dialog.vue';

import EventBus from '@/utils/EventBus';
import { LOTTO_INSTANT } from '@/constants/lotto/instant-lotto';

export default {
    mixins: [languageMixins, functionMixins, printMixins],
    components: { ButtonCommon, Dialog },
    data() {
        return {
            isLoadingButton: false,
            phoneNumber: '',
            dialog: {
                isOpen: false,
                isOpenRaffle: false,
            },

            LOTTO_INSTANT,
        };
    },
    computed: {
        ...mapState(['ModulesInstantLotto']),
    },
    methods: {
        showNotification(message, type) {
            const param = { text: message, type };
            EventBus.emit('show-notications', param);
        },

        async onTransactCart() {
            this.isLoadingButton = true;
            try {
                const respCheckDevice = await LottoService.deviceBindingcheck();
                if (respCheckDevice.code === 200 || respCheckDevice.status === 'success') {
                    const respToken = await LottoService.getTokenDaily();
                    if (respToken.code === 200 || respToken.status === 'success') {
                        const entries = [];

                        this.ModulesInstantLotto.cartInstant.forEach((x) => {
                            const item = {
                                draws: 1,
                                eventDate: x.eventDate,
                                game: x.slug,
                                selection: [x.selection],
                                wager: x.price,
                            };

                            entries.push(item);
                        });

                        const resp = await LottoService.transactBetLotto(entries, LOTTO_INSTANT.SLUG_API);

                        if (resp.status === 'success' && resp.code === 200) {
                            this.printLottoInstant(resp.data);
                            this.showReprintDialog(resp.data);
                        } else {
                            this.showNotification(resp.message, 'warning');
                        }
                    } else {
                        this.showNotification(respToken.message, 'error');
                    }
                } else {
                    this.showNotification(respCheckDevice.message, 'error');
                }
            } catch (error) {
                this.showNotification(
                    error === 'ECONNABORTED'
                        ? this.getTranslatedText('Request timeout. Please check your network connection.')
                        : error,
                    'error',
                );
            } finally {
                this.isLoadingButton = false;
            }
        },

        showReprintDialog(paramPrint) {
            this.onClearCart();
            let betslipId = paramPrint?.transaction?.externalId ?? paramPrint?.transaction?.external_id ?? '';
            EventBus.emit('on-show-reprint', {
                ticketType: 'L',
                reference: paramPrint?.transaction?.reference,
                betslipId: betslipId.startsWith('L-') ? betslipId : 'L-' + betslipId,
                paramPrint: paramPrint,
                forLotto: true,
                forLottoType: LOTTO_INSTANT.SLUG_GAME
            });
        },

        //Action remove cart
        onShowConfirmClear() {
            this.dialog.isOpen = true;
        },

        onClearCart() {
            const payload = {
                cart: [],
                total: 0,
            };
            this.$store.dispatch('ModulesInstantLotto/actionRemoveCart', payload);
            this.dialog.isOpen = false;
        },

        onRemoveItem(item) {
            const index = this.ModulesInstantLotto.cartInstant.findIndex((x) => x.id === item.id);
            if (index !== -1) {
                const payload = {
                    cart: this.ModulesInstantLotto.cartInstant,
                };
                payload.cart.splice(index, 1);
                payload['total'] = payload['cart'].length;
                this.$store.dispatch('ModulesInstantLotto/actionRemoveCart', payload);
            }
        },

        // common
        renderTextTickets(arr) {
            let valueBallRender = '';
            arr.forEach((x, index) => {
                valueBallRender = `${valueBallRender}${index !== 0 ? ', ' : ''}${x}`;
            });
            return valueBallRender;
        },

        renderDate(date) {
            const dateFormat = formatDateUTC(date, 2);
            const { hour, minutes, day, year, month } = dateFormat;

            const time = ` ${hour}:${minutes}`;

            const valueDate = `${day}/${month}/${year} ${time}`;

            return valueDate;
        },

        renderTotal() {
            const data = this.ModulesInstantLotto.cartInstant;
            const totalPrice = data.reduce((acc, item) => acc + parseFloat(item.price), 0);
            return this.renderPrice(totalPrice);
        },

        renderPrice(price, decimal = 2) {
            const priceFormat = `${this.$store.state.config.setup.currency} ${formatPrice(price, decimal)}`;
            return priceFormat;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/betslip/betslip-lotto-card.scss';
</style>
